import { __ } from '~@/Composables/translation'

/**
 * Normalises the payload of a failed connection-check request into the shape
 * DConnectionErrorModal expects (a FlashMessage: title/body/error/link/errorTrace).
 *
 * Controllers return a FlashMessage under `exception` for handled failures. An
 * *unhandled* error instead yields Laravel's debug payload, where `exception` is
 * the exception class name — a plain string. Assigning that straight to the modal
 * leaves every field undefined and renders an empty dialog, so fall back to
 * `message` and present it as the error instead.
 *
 * @param {object|undefined} responseData `error.response.data` of the failed request
 * @returns {object|null} FlashMessage-shaped object, or null when there is nothing to show
 */
export function toConnectionException (responseData) {
    const exception = responseData?.exception

    if (typeof exception === 'object' && exception !== null) {
        return exception
    }

    const error = responseData?.message ?? (typeof exception === 'string' ? exception : null)

    if (!error) {
        return null
    }

    return {
        title: __('messages.messages.title'),
        body: __('messages.messages.body'),
        error,
        errorTrace: []
    }
}

/**
 * Flattens Laravel's validation error bags (`{field: [message, ...]}`) into the
 * `{field: message}` shape the form rows render.
 *
 * @param {object|undefined} responseData `error.response.data` of the failed request
 * @returns {object} flattened errors, empty when the response carried none
 */
export function toFlatValidationErrors (responseData) {
    if (responseData?.errors === undefined) {
        return {}
    }

    const errors = { ...responseData.errors }

    for (const key in errors) {
        if (Array.isArray(errors[key]) || typeof errors[key] === 'object') {
            errors[key] = errors[key][0]
        }
    }

    return errors
}
